export const getLandingQuestions = (t) => [
  {
    question: t("landing.faqs.question_01"),
    answer: t("landing.faqs.answer_01"),
  },
  {
    question: t("landing.faqs.question_02"),
    answer: t("landing.faqs.answer_02"),
  },
  {
    question: t("landing.faqs.question_03"),
    answer: t("landing.faqs.answer_03"),
  },
  {
    question: t("landing.faqs.question_04"),
    answer: t("landing.faqs.answer_04"),
  },
  {
    question: t("landing.faqs.question_05"),
    answer: t("landing.faqs.answer_05"),
  },
];
